module.exports = __webpack_public_path__ + "static/img/company-about-us-page.a294f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/company-about-us-page.png
// module id = mXhl
// module chunks = 1